// import React, { useState } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { createKitchenDining } from "../../../redux/actions/kitchenDiningActions";

// const SectionIFoodHygiene = () => {
//   const navigate = useNavigate();
//   const { state } = useLocation();
// const dispatch = useDispatch();
// const plateMap = {
//   thermocol: 1,
//   aluminium: 2,
//   steel: 3,
//   plastic: 4,
//   other: 5,
// };

//   const [form, setForm] = useState({
//     i1: "",
//   });

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm(prev => ({ ...prev, [name]: value }));
    
//     // Clear error when user makes a selection
//     if (errors[name]) {
//       setErrors(prev => ({ ...prev, [name]: "" }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
    
//     // Required field validations
//     if (!form.i1) newErrors.i1 = "This field is required";
    
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   /* ================================
//      SAVE TO LOCAL STORAGE
//   ================================ */
//   // const handleSave = () => {
//   //   if (!validateForm()) {
//   //     // alert("Please fill in all required fields correctly before saving.");
//   //     return;
//   //   }

//   //   try {
//   //     // Save form data to localStorage
//   //     const surveyData = JSON.parse(localStorage.getItem("surveyData") || "{}");
//   //     surveyData.sectionI = form;
//   //     localStorage.setItem("surveyData", JSON.stringify(surveyData));

//   //     // Mark Section I as completed
//   //     const completedSections = JSON.parse(localStorage.getItem("completedSections") || "{}");
//   //     completedSections.i = true;
//   //     localStorage.setItem("completedSections", JSON.stringify(completedSections));

//   //     // Navigate back to sections
//   //     navigate("/survey/sections", { state });
      
//   //     // Show success message
//   //     alert("Section I saved successfully!");
//   //   } catch (err) {
//   //     console.error("Error saving data:", err);
//   //     alert("Error saving data. Please try again.");
//   //   }
//   // };
// const handleSave = async () => {
//   if (!validateForm()) return;

//   try {
//     const fd = new FormData();

//     /* ================================
//        LOCATION DATA
//     ================================ */
//     fd.append("district_id", state.district_id);
//     fd.append("municipality_id", state.municipality_id);
//     fd.append("ward_id", state.ward_id);
//     fd.append("area_id", state.area_id);
//     fd.append("canteen_type_id", state.canteen_type_id);

//     /* ================================
//        FOOD HYGIENE – I1
//     ================================ */
//     fd.append("food_hygn_I1", plateMap[form.i1]);

//     /* ================================
//        CURRENT SECTION
//     ================================ */
//     fd.append("current_section", "foodhygiene");

//     /* ================================
//        AUTO LAT / LNG
//     ================================ */
//     navigator.geolocation.getCurrentPosition(
//       async (pos) => {
//         fd.append("latitude", pos.coords.latitude);
//         fd.append("longitude", pos.coords.longitude);

//         /* ================================
//            API CALL
//         ================================ */
//         await dispatch(createKitchenDining(fd));

//         /* ================================
//            LOCAL STORAGE ✅
//         ================================ */
//         const completedSections = JSON.parse(
//           localStorage.getItem("completedSections") || "{}"
//         );
//         completedSections.i = true;
//         localStorage.setItem(
//           "completedSections",
//           JSON.stringify(completedSections)
//         );

//         const surveyData = JSON.parse(
//           localStorage.getItem("surveyData") || "{}"
//         );
//         surveyData.sectionI = form;
//         localStorage.setItem("surveyData", JSON.stringify(surveyData));

//         // alert("Section I saved successfully!");
//         navigate("/survey/sections", { state });
//       },
//       (err) => {
//         console.error(err);
//         alert("Location permission is required");
//       }
//     );
//   } catch (err) {
//     console.error("Section I submit error:", err);
//     alert("Something went wrong. Please try again.");
//   }
// };
//   const plateOptions = [
//     { value: "thermocol", label: "1. Thermocol plates" },
//     { value: "aluminium", label: "2. Aluminium foil plates" },
//     { value: "steel", label: "3. Steel plates" },
//     { value: "plastic", label: "4. Plastic plates" },
//     { value: "other", label: "5. Other" }
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50 p-4">
//       <div className="max-w-4xl mx-auto">
//         <div className="bg-white rounded-xl shadow p-6">
//           <div className="flex items-center justify-between mb-6">
//             <div>
//               <h2 className="text-2xl font-bold text-gray-800">Section I: Food Hygiene</h2>
//               <p className="text-gray-600">Food serving materials</p>
//             </div>
//             <div className="text-sm bg-pink-100 text-pink-800 px-3 py-1 rounded-full">
//               {state?.canteenId ? `Canteen ID: ${state.canteenId}` : 
//                state?.kioskId ? `Kiosk ID: ${state.kioskId}` : "N/A"}
//             </div>
//           </div>

//           <div className="space-y-6">
//             {/* I1 */}
//             <div className="border rounded-lg p-4">
//               <label className="block font-medium mb-3">
//                 I.1 What type of plates are used for serving food to the beneficiaries? <span className="text-red-500">*</span>
//               </label>
//               <div className="space-y-3 mb-4">
//                 {plateOptions.map((option) => (
//                   <label 
//                     key={option.value}
//                     className={`flex items-center p-3 border rounded cursor-pointer ${
//                       form.i1 === option.value ? 'bg-blue-50 border-blue-300' : ''
//                     } ${errors.i1 ? 'border-red-300' : ''}`}
//                   >
//                     <input
//                       type="radio"
//                       name="i1"
//                       value={option.value}
//                       checked={form.i1 === option.value}
//                       onChange={handleChange}
//                       className="mr-3 h-5 w-5"
//                       required
//                     />
//                     <span>{option.label}</span>
//                   </label>
//                 ))}
//               </div>
//               {errors.i1 && <p className="text-red-500 text-sm mt-2">{errors.i1}</p>}
              
//               {form.i1 === "other" && (
//                 <div className="mt-4">
//                   <label className="block text-sm font-medium mb-2">
//                     Please specify what other type of plates are used:
//                   </label>
//                   <input
//                     type="text"
//                     name="i1Remarks"
//                     placeholder="Specify other type of plates used..."
//                     className="w-full border p-3 rounded"
//                     value={form.i1Remarks || ""}
//                     onChange={handleChange}
//                   />
//                 </div>
//               )}
//             </div>

//             {/* Required fields note */}
//             <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4">
//               <div className="flex">
//                 <div className="flex-shrink-0">
//                   <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
//                     <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                   </svg>
//                 </div>
//                 <div className="ml-3">
//                   <p className="text-sm text-yellow-700">
//                     <span className="text-red-500">*</span> indicates required fields. All fields must be completed before saving.
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Navigation Buttons */}
//             <div className="flex justify-between pt-6 border-t">
//               <button
//                 onClick={() => navigate("/survey/sections", { state })}
//                 className="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
//               >
//                 Back to Sections
//               </button>
//               <button
//                 onClick={handleSave}
//                 className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
//               >
//                 Save Section I
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SectionIFoodHygiene;
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { createKitchenDining } from "../../../redux/actions/kitchenDiningActions";
import { useLanguage } from "../../../context/LanguageContext";

const SectionIFoodHygiene = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { t } = useLanguage();

  /* ================================
     FORM STATE
  ================================ */
  const [form, setForm] = useState({
    i1: null,          // 1–5
    i1Remarks: "",     // only for "Other"
  });

  const [errors, setErrors] = useState({});

  /* ================================
     OPTIONS (NUMERIC VALUES)
  ================================ */
  const plateOptions = [
    { value: 1, label: `1. ${t.modules.kitchenCumDining.sections.I.options.plateType[0]}` },
    { value: 2, label: `2. ${t.modules.kitchenCumDining.sections.I.options.plateType[1]}` },
    { value: 3, label: `3. ${t.modules.kitchenCumDining.sections.I.options.plateType[2]}` },
    { value: 4, label: `4. ${t.modules.kitchenCumDining.sections.I.options.plateType[3]}` },
    { value: 5, label: `5. ${t.modules.kitchenCumDining.sections.I.options.plateType[4]}` },
  ];

  /* ================================
     HANDLE CHANGE
  ================================ */
  const handleChange = (e) => {
    const { name, value, type } = e.target;

    const finalValue = type === "radio" ? Number(value) : value;

    setForm((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  /* ================================
     VALIDATION
  ================================ */
  const validateForm = () => {
    const newErrors = {};

    if (!form.i1) {
      newErrors.i1 = t.global.err_a1;
    }

    if (form.i1 === 5 && !form.i1Remarks.trim()) {
      newErrors.i1Remarks = "Please specify other type of plates";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ================================
     SAVE / SUBMIT
  ================================ */
  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      const fd = new FormData();

      /* Location data */
      fd.append("district_id", state.district_id);
      fd.append("municipality_id", state.municipality_id);
      fd.append("ward_id", state.ward_id);
      fd.append("area_id", state.area_id);
      fd.append("canteen_type_id", state.canteen_type_id);
      fd.append("reporting_date", new Date().toISOString().split("T")[0]);

      /* Section I data */
      fd.append("food_hygn_I1", form.i1);
      if (form.i1 === 5) {
        fd.append("food_hygn_I1_remarks", form.i1Remarks);
      }

      fd.append("current_section", "food_hygine");

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          fd.append("latitude", pos.coords.latitude);
          fd.append("longitude", pos.coords.longitude);

          await dispatch(createKitchenDining(fd));

          /* Local storage */
          const completedSections = JSON.parse(
            localStorage.getItem("completedSections") || "{}"
          );
          completedSections.i = true;
          localStorage.setItem(
            "completedSections",
            JSON.stringify(completedSections)
          );

          const surveyData = JSON.parse(
            localStorage.getItem("surveyData") || "{}"
          );
          surveyData.sectionI = form;
          localStorage.setItem("surveyData", JSON.stringify(surveyData));

          navigate("/survey/sections", { state });
        },
        () => alert(t.global.alert_missing_ids)
      );
    } catch (err) {
      console.error("Section I submit error:", err);
      alert(t.global.alert_server_error);
    }
  };

  /* ================================
     UI
  ================================ */
  return (
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-2xl font-bold mb-2">
            {t.modules.kitchenCumDining.sections.I.title}
          </h2>
          <p className="text-gray-600 mb-6">
            {t.modules.kitchenCumDining.sections.I.subtitle}
          </p>

          {/* I1 */}
          <div className="border rounded-lg p-4 mb-6">
            <label className="block font-medium mb-3">
              I.1 {t.modules.kitchenCumDining.sections.I.questions.plateType}
              <span className="text-red-500">*</span>
            </label>

            <div className="space-y-3">
              {plateOptions.map((option) => (
                <label
                  key={option.value}
                  className={`flex items-center p-3 border rounded cursor-pointer ${
                    form.i1 === option.value
                      ? "bg-blue-50 border-blue-400"
                      : ""
                  } ${errors.i1 ? "border-red-300" : ""}`}
                >
                  <input
                    type="radio"
                    name="i1"
                    value={option.value}
                    checked={form.i1 === option.value}
                    onChange={handleChange}
                    className="mr-3 h-5 w-5"
                  />
                  {option.label}
                </label>
              ))}
            </div>

            {errors.i1 && (
              <p className="text-red-500 text-sm mt-2">
                {errors.i1}
              </p>
            )}

            {/* OTHER REMARKS */}
            {form.i1 === 5 && (
              <div className="mt-4">
                <label className="block text-sm font-medium mb-2">
                  Please specify:
                </label>
                <input
                  type="text"
                  name="i1Remarks"
                  className="w-full border p-3 rounded"
                  value={form.i1Remarks}
                  onChange={handleChange}
                />
                {errors.i1Remarks && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.i1Remarks}
                  </p>
                )}
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="flex justify-between border-t pt-6">
            <button
              onClick={() => navigate("/survey/sections", { state })}
              className="px-6 py-3 bg-gray-200 rounded hover:bg-gray-300"
            >
              {t.global.back_to_sections}
            </button>

            <button
              onClick={handleSave}
              className="px-6 py-3 bg-green-600 text-white rounded hover:bg-green-700"
            >
              {t.global.submit_section_i}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionIFoodHygiene;
